module.exports = __webpack_public_path__ + "d70ee9c920f200f7f39b70a784e08a9b.svg";